import { GTM_ID } from "../config";

export const initGTM = () => {
  const gtmId = GTM_ID;

  if (
    !gtmId ||
    gtmId.startsWith("GTM-XXXXXXX") ||
    gtmId.startsWith("GTM-YYYYYYY") ||
    gtmId.startsWith("GTM-STAGING") ||
    gtmId.startsWith("GTM-PROD")
  ) {
    return;
  }

  // Google Tag Manager Script
  const script = document.createElement("script");
  script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');
  `;
  document.head.appendChild(script);
};
